import { type ReactNode } from 'react';
import { DirtyStateProvider } from './providers/DirtyStateProvider';
import { ScopeTransitionProvider } from './providers/ScopeTransitionProvider';
import { ScopeChangeGuardProvider } from './providers/ScopeChangeGuardProvider';
import { ResolutionProvider } from './providers/ResolutionProvider';

export interface ChangeProtectionProviderProps {
  children: ReactNode;
}

export const ScopeChangeProvider = ({
  children,
}: ChangeProtectionProviderProps) => {
  return (
    <DirtyStateProvider>
      <ScopeTransitionProvider>
        <ResolutionProvider>
          <ScopeChangeGuardProvider enabled>
            {children}
          </ScopeChangeGuardProvider>
        </ResolutionProvider>
      </ScopeTransitionProvider>
    </DirtyStateProvider>
  );
};
